<svelte:options accessors/>
<script lang="ts">
    import type {IBillingForm, IProfileData} from "../../interfaces";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";
    import Subtotal from "./Subtotal.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import {Cart, getCart} from "../../models/cart";
    import LinearProgress from "@smui/linear-progress";
    import CartSummary from "./CartSummary.svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import Snackbar, {Label, SnackbarComponentDev} from "@smui/snackbar";
    import IconButton from '@smui/icon-button';
    import Adviser from "../Adviser.svelte";

    const dispatch = createEventDispatcher();


    export let loading: boolean = true;
    export let urlPay: string;
    let cart: Cart;
    export let profile: IProfileData;
    export let useShipping: boolean = false;
    export let enableAdviser: boolean = false;
    export let departments: Array<any> = [];

    export let dialogOrder: any = {
        open: false
    }

    let order: any;

    export let data: IBillingForm = {
        first_name: profile ? profile.first_name ?? '' : '',
        last_name: profile ? profile.last_name ?? '' : '',
        last_name_2: profile ? profile.last_name_2 ?? '' : '',
        type_identification: profile ? profile.type_identification ?? null : null,
        identification: profile ? profile.identification ?? '' : '',
        email: profile ? profile.email ?? '' : '',
        phone: profile ? profile.phone ?? '' : '',
        department: null,
        city: null,
        billing_address: profile?.billing_address ?? '',
        accept_treatment: false,
        accept_delivery_policy: false,
        accept_promos: false,
        accept_remember: false
    };

    export let adviser = {
        name: '',
        doc: ''
    }
    let department = null;
    let dialog = {
        open: false,
        message: ''
    };
    let snackbarCmpt;
    onMount(() => {
        getCart().then((c) => {
            cart = c;
            const billing = cart?.billing ?? {};
            const info = fromProfile();
            data = {
                first_name: info.first_name,
                last_name: info.last_name,
                last_name_2: info.last_name_2,
                type_identification: info.type_identification,
                identification: info.identification,
                email: info.email,
                phone: info.phone,
                department: null,
                city: null,
                billing_address: info.billing_address,
                accept_treatment: !!billing?.accept_delivery_policy,
                accept_delivery_policy: !!billing?.accept_delivery_policy,
                accept_promos: !!billing?.accept_promos,
                accept_remember: !!billing?.accept_remember
            };
            if (billing.department) {
                data.department = departments.find(d => d.id === billing.department.id)
            } else if (profile.department) {
                data.department = departments.find(d => d.id === profile.department.id)
            }
            if (data.department) {
                if (billing.city) {
                    data.city = data.department.cities.find(c => c.id === billing.city.id);
                } else if (profile.city) {
                    data.city = data.department.cities.find(c => c.id === profile.city.id);
                }
            }
            adviser = cart.adviser ? cart.adviser : adviser;
            loading = false;
        });
    });

    function fromProfile() {
        return {
            first_name: profile?.first_name ?? '',
            last_name: profile?.last_name ?? '',
            last_name_2: profile?.last_name_2 ?? '',
            type_identification: profile?.type_identification ?? null,
            identification: profile?.identification ?? '',
            email: profile?.email ?? '',
            phone: profile?.phone ?? '',
            department: null,
            city: null,
            billing_address: profile?.billing_address ?? '',
            accept_treatment: false,
            accept_delivery_policy: false,
            accept_promos: false,
            accept_remember: false
        };
    }

    function valid() {
        const options = [
            !!data.first_name,
            !!data.last_name,
            !!data.last_name_2,
            !!data.type_identification,
            !!data.identification,
            !!data.email,
            !!data.phone,
            !!data.department,
            !!data.city,
            !!data.billing_address,
            !!data.accept_treatment,
            !!data.accept_delivery_policy,
            !!data.accept_promos,
            !!data.accept_remember
        ];
        if (enableAdviser) {
            options.push(!!adviser.name);
            options.push(!!adviser.doc);
        }
        return options.every(o => !!o);
    }

    async function next() {
        if (valid()) {
            await update();
            await createOrder();
        } else {
            snackbarCmpt.open();
        }
    }

    async function createOrder() {
        try {
            loading = true;
            order = await cart.createOrder();
            if (order) {
                dialogOrder.open = true;
            } else {
                dialog.message = 'Se presento un error generando el pedido'
                dialog.open = true;
            }
            loading = false;
        } catch (e) {
            order = null;
            loading = false;
            dialog.message = 'Se presento un error generando el pedido'
            dialog.open = true;
        }
    }

    async function update() {
        loading = true;
        cart.billing = data;
        // cart.adviser = enableAdviser ? adviser : null;
        await cart.update();
        loading = false;
    }

    async function genLink() {
        await update();
        const url = `${window.origin}/checkout/asesor?carrito=${cart.cartId}`;
        dialog.message = `Link para compartir el carrito de compras: <b>${url}</b>`;
        dialog.open = true;
    }

    function closeOrderModal(url: string) {
        window.open(url, '_blank');
        dialogOrder.open = false;
        dispatch('finish');
    }
</script>
{#if cart}
    <section class="py-2 mb-3 max-w-900px mx-auto">
        <div class="container">
            {#if loading}
                <div class="container">
                    <div class="text-c loading-bar">
                        <LinearProgress class="w-100" indeterminate/>
                        <small>Procesando...</small>
                    </div>
                </div>
            {:else}
                <CartSummary {cart}/>
                <h2 class="mb-15">Información personal</h2>
                <fieldset class="mb-15">
                    <div class="naui-field mb-1">
                        <input type="text" bind:value={data.first_name} class="naui-input"
                               placeholder="Nombres"/>
                    </div>
                    <div class="naui-field mb-1">
                        <input type="text" bind:value={data.last_name} class="naui-input"
                               placeholder="Apellido">
                    </div>
                    <div class="naui-field mb-1">
                        <input type="text" bind:value={data.last_name_2} class="naui-input"
                               placeholder="Segundo apellido">
                    </div>
                    <div class="naui-field mb-1">
                        <select class="naui-input" bind:value={data.type_identification}>
                            <option value="{null}" selected hidden>Tipo de identificación</option>
                            <option value="cc">Cédula de ciudadanía</option>
                            <option value="ti">Tarjeta de identidad</option>
                            <option value="ce">Cédula de extranjería</option>
                            <option value="passport">Pasaporte</option>
                            <option value="nit">NIT</option>
                            <option value="die">Documento de identificación extranjero</option>
                            <option value="niup">NIUP</option>
                        </select>
                        <span></span>
                    </div>
                    <div class="naui-field mb-1">
                        <input bind:value={data.identification} class="naui-input" type="number"
                               placeholder="Número de identificación">
                        <small>Por favor no digitar puntos, comas, guiones ni caracteres especiales.</small>
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Datos de contacto</legend>
                    <div class="naui-field mb-1">
                        <input type="email"
                               class="naui-input"
                               placeholder="Correo electrónico"
                               bind:value={data.email}>
                    </div>
                    <div class="naui-field mb-1">
                        <input type="text"
                               class="naui-input"
                               placeholder="Teléfono"
                               bind:value={data.phone}>
                    </div>
                    <div class="naui-field mb-1">
                        <select class="naui-input" bind:value={data.department}>
                            <option value={null}>Seleccione un departamento</option>
                            {#each departments as d}
                                <option value={d}>{d.name}</option>
                            {/each}
                        </select>
                    </div>
                    <div class="naui-field mb-1">
                        <select class="naui-input" bind:value={data.city}>
                            <option value={null}>Seleccione una ciudad</option>
                            {#if data.department}
                                {#each data.department.cities as c}
                                    <option value={c}>{c.name}</option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                    <div class="naui-field mb-1">
                        <input type="text"
                               class="naui-input"
                               placeholder="Dirección de Facturación (*)"
                               bind:value={data.billing_address}>
                    </div>
                    <div class="naui-field mb-1">
                        <NauiCheckbox bind:value={useShipping}
                                      label="Usar dirección de envío seleccionada"/>
                    </div>
                </fieldset>
                <!--fieldset class="py-1">
                    <Adviser {cart}
                             {adviser}/>
                </fieldset-->
                <fieldset>
                    <strong>Tu información está segura</strong>
                    <p>Acepta nuestros términos y condiciones para continuar con el proceso</p>
                    <div class="py-2">
                        <NauiCheckbox label="He leído y acepto la política de tratamiento de datos personales"
                                      bind:value={data.accept_treatment}/>
                        <NauiCheckbox label="He leído y acepto la política de envíos, transporte y devoluciones"
                                      bind:value={data.accept_delivery_policy}/>
                        <NauiCheckbox
                                label="Acepto el uso de mis datos personales para recibir promociones, ofertas y novedades"
                                bind:value={data.accept_promos}/>
                        <NauiCheckbox label="Acepto que se recuerden mis datos para futuras compras"
                                      bind:value={data.accept_remember}/>
                    </div>
                    <a href="/derecho-retracto" target="_blank">
                        <p class="underlined">Derecho de retracto</p>
                    </a>
                </fieldset>
            {/if}
        </div>
    </section>
    {#if !loading}
        <Subtotal subtotal={cart.subtotal}
                  label="Ir a pagar"
                  on:click={()=>next()}/>
    {/if}
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-1 w-100">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={() => {dialog.open = false;}}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbarCmpt}>
    <Label>Datos incompletos o invalidos.</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbarCmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>

<Dialog bind:open={dialogOrder.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        <b>A continuación serás redirigido a nuestra plataforma de pagos</b>
    </Content>
    <Actions>
        {#if order?.order_code}
            <div class="box sx-ii">
                <a on:click={()=>closeOrderModal(`${urlPay}=${order.order_code}`)}
                   target="_blank"
                   class="btn accent">
                    ENTENDIDO
                </a>
            </div>
        {/if}
    </Actions>
</Dialog>